import { render, staticRenderFns } from "./Tabber.vue?vue&type=template&id=4932e79e&"
import script from "./Tabber.vue?vue&type=script&lang=js&"
export * from "./Tabber.vue?vue&type=script&lang=js&"
import style0 from "./Tabber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports